<script lang="ts" setup>
import { ComboboxOptions } from '@headlessui/vue'
</script>

<template>
  <ComboboxOptions
    static
    class="mt-4 flex flex-wrap gap-2"
  >
    <slot />
  </ComboboxOptions>
</template>
